// DesktopUI
import photo from "./images/grand-pere.png";
import mailDesktopBackground from "./images/mail_desktop_background.png";
import fragmentSvg from "./images/svg/fragment_button.svg";
import mailDesktopIcon from "./images/svg/mail_desktop_icon.svg";
// EndUI
import endPhoto from "./images/end_photo.png";
import endDoorBackground from "./images/fond_sans_porte.jpg";
import singleDoor from "./images/single_door.png";
import logo from "./images/logo_reves.png";
// MoonUI
import moonImg from "./images/moon_v1.png";
import starsBackground1 from "./images/svg/stars_background_1.svg";
import starsBackground2 from "./images/svg/stars_background_2.svg";
import starsBackground3 from "./images/svg/stars_background_3.svg";
// Mobile
import mobileBackground from "./images/mobile_background_image.png";


// Video
import video from "./video/timelapse.mp4";

export const images = {
  // Mobile
  mobileBackground,
  // DesktopUI
  photo,
  mailDesktopBackground,
  fragmentSvg,
  mailDesktopIcon,
  // EndUI
  endPhoto,
  endDoorBackground,
  singleDoor,
  logo,
  // MoonUI
  moonImg,
  starsBackground1,
  starsBackground2,
  starsBackground3,
};


export const videos = {
  video
}


export const audios = {
  // --------- HUB SCENE ---------
  // SOUND DESIGN HUB SCENE
  background_music: "./audio/background_music.mp3",
  clickBuzzer: "./audio/soundDesign/intro/click_buzzer.wav",
  piano: "./audio/soundDesign/interactUI/piano.mp3",
  swoosh_intro_cloud: "./audio/soundDesign/hub/swoosh_intro_cloud.mp3",
  swoosh_computer_in: "./audio/soundDesign/hub/swoosh_computer_in.mp3",
  swoosh_computer_out: "./audio/soundDesign/hub/swoosh_computer_out.mp3",
  door_opening: "./audio/soundDesign/hub/door_opening.mp3",
  // AUDIO HUB SCENE
  introduction: "./audio/v2/introduction.mp3",
  mail_accepte: "./audio/v2/mail_accepte.mp3",
  mail_superflamme: "./audio/v2/mail_superflamme.mp3",
  transition_nuage: "./audio/v2/transition_nuage.mp3",
  fragments_etoiles: "./audio/v2/fragments_etoiles.mp3",
  // --------- SECONDARY SCENE ---------
  // RoomScene
  swoosh_telescope_in: "./audio/soundDesign/room/swoosh_telescope_in.mp3",
  swoosh_telescope_out: "./audio/soundDesign/room/swoosh_telescope_out.mp3",
  swoosh_cloud_to_room: "./audio/soundDesign/room/swoosh_cloud_to_room.mp3",
  entree_chambre: "./audio/v2/entree_chambre.mov",
  debut_telescope: "./audio/v2/debut_telescope.mp3",
  focus_telescope: "./audio/v2/focus_telescope.mp3",
  // MoonUI
  lune_trouvee: "./audio/soundDesign/moon/lune_trouvee.mp3",
  focal_simple_clic: "./audio/soundDesign/moon/focal_simple_clic.mp3",
  fin_telescope: "./audio/v2/fin_telescope.mp3",
  // Timelapse
  timelapse: "./audio/v2/timelapse.mp3",
  // TuyauScene
  pipe_tourner: "./audio/soundDesign/tuyau/pipe_tourner.mp3",
  liquide: "./audio/soundDesign/tuyau/liquide.mp3",
  fin_carburant: "./audio/v2/fin_carburant.mp3",
  encouragement_emotion: "./audio/v2/encouragement_emotion.mp3",
  mathis_error: "./audio/v2/mathis_error.mp3",
  fond_sonor_machine: "./audio/soundDesign/tuyau/fond_sonor_machine.mp3",
  levier: "./audio/soundDesign/tuyau/levier.mp3",
  // BuzzerScene / FuseeScene
  fin_experience: "./audio/v2/fin_experience.mp3",
  rocket_launch: "./audio/soundDesign/fusee/rocket_launch.mp3",
  heart_beating: "./audio/soundDesign/fusee/heart_beating.mp3",
  heart_beating_appears: "./audio/soundDesign/fusee/heart_beating_appears.mp3",
  instruction_buzzer: "./audio/v2/instruction_buzzer.mp3",
}


export const subtitles = {
  // ----------- HUB SCENE -----------
  introduction: "./audio/subtitles/v2/introduction.srt",
  mail_accepte: "./audio/subtitles/v2/mail_accepte.srt",
  mail_superflamme: "./audio/subtitles/v2/mail_superflamme.srt",
  transition_nuage: "./audio/subtitles/v2/transition_nuage.srt",
  fragments_etoiles: "./audio/subtitles/v2/fragments_etoiles.srt",
  // ---------- SECONDARY SCENE ----------
  // RoomScene
  entree_chambre: "./audio/subtitles/v2/entree_chambre.srt",
  debut_telescope: "./audio/subtitles/v2/debut_telescope.srt", 
  focus_fusee: "./audio/subtitles/v2/focus_fusee.srt",
  fin_telescope: "./audio/subtitles/v2/fin_telescope.srt",
  focus_telescope: "./audio/subtitles/v2/focus_telescope.srt",
  // Timelapse
  timelapse: "./audio/subtitles/v2/timelapse.srt",
  // TuyauScene
  fin_carburant: "./audio/subtitles/v2/fin_carburant.srt",
  encouragement_emotion: "./audio/subtitles/v2/encouragement_emotion.srt",
  mathis_error: "./audio/subtitles/v2/mathis_error.srt",
  // BuzzerScene / FuseeScene
  instruction_buzzer: "./audio/subtitles/v2/instruction_buzzer.srt",
  // ENDUI
  fin_experience: "./audio/subtitles/v2/fin_experience.srt"
}